import { render, staticRenderFns } from "./RecentCustList.vue?vue&type=template&id=7b18d6c9&scoped=true"
import script from "./RecentCustList.vue?vue&type=script&lang=js"
export * from "./RecentCustList.vue?vue&type=script&lang=js"
import style0 from "./RecentCustList.vue?vue&type=style&index=0&id=7b18d6c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18d6c9",
  null
  
)

export default component.exports